<template>
  <div>
    <div class="mainView">
      <div class="miniDiv">
        <i class="iconfont icon-zuixiaohua fsize" @click="min()"></i>
        <i class="iconfont icon-guanbi fsize" @click="close()" style="margin-left: 10px;"></i>
      </div>

      <div class="loginBox shadow-1">
        <div class="loginBoxLeft">
          <img src="@/img/tree.jpg" class="tree">
          <span class="loginBoxText" @click="login()" style="-webkit-app-region: no-drag;">人力资源部</span>
          <span class="loginBoxTextSmall">考勤管理平台</span>
        </div>
        <div class="loginBoxRight" style="-webkit-app-region: no-drag;">
          <img src="@/img/circle.png" class="circle1">
          <img src="@/img/circle.png" class="circle1">
          <img src="@/img/circle.png" class="circle2">
          <img src="@/img/circle.png" class="circle2">

          <div class="loginRight">
            <img src="@/img/01.png" class="zuo">
            <div class="you">用 户 名：</div> <input placeholder="请输入用户名称" v-model="loginName" class="input" />
          </div>
          <div class="loginRight" style="margin-top: 15px;">
            <img src="@/img/02.png" class="zuo">
            <div class="you">密 　 码：</div> <input type="password" class="input" v-model="passwd" placeholder="请输入用户密码" />
          </div>

          <div class="bottowDiv" @click="login()">登录</div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  export default {
    components: {},
    data() {
      return {
        loginName: "",
        passwd: ""
      }
    },
    watch: {},
    computed: {},
    methods: {
      login() {
        let curr = this;
        let config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        axios.post(curr.appURL+'/renli.php', {
            type: 'login',
            login_id: this.loginName,
            passwd: this.passwd,
          }, config)
          .then(function(res) {
            if(res.data.code == 0 ){
              localStorage.token = res.data.token;
              curr.$router.push('/main');
            }else if(res.data.code == 500){
              console.log('失败');
              curr.$message({
                message: res.result
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
        // this.$router.push('/main');
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if ('401' === vm.$route.query.error) {
          vm.$message.error('登录超时，请重新登录！')
        }
      })
    }
  }
</script>
<style scoped>
  /* 阴影 */
  .shadow-1 {
    box-shadow: 0px 0px 20px 3px rgba(23, 106, 180, 0.3);
  }

  .mainView {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url("~@/img/loginBgImage.jpg");
    background-size: cover;
    background-position: center center;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .loginBox {
    display: flex;
    flex-direction: row;
    width: 750px;
    height: 450px;
    background-color: white;
    border-radius: 20px;
  }

  .loginBoxLeft {
    width: 280px;
    height: 100%;
    background-color: #222c59;
    border-radius: 20px 0px 0px 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;

  }

  .tree {
    width: 280px;
    display: flex;
    margin-top: auto;
    margin-bottom: 0px;
    border-bottom-left-radius: 20px;
  }

  .loginBoxText {
    position: absolute;
    top: 30px;
    font-family: '微软雅黑', '黑体';
    font-size: 36px;
    color: white;
  }

  .loginBoxTextSmall {
    position: absolute;
    top: 80px;
    font-family: '微软雅黑', '黑体';
    font-size: 16px;
    color: #aaaaaa;
  }

  .loginBoxRight {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;

  }

  .barCode {
    box-sizing: border-box;
    width: 220px;
    height: 220px;
    padding: 10px;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.3);
  }

  .circle1 {
    position: absolute;
    top: -20px;
    right: -80px;
    transform: scale(0.7)
  }

  .circle2 {
    position: absolute;
    top: 30px;
    right: -60px;
    transform: scale(0.8)
  }

  .loginBoxRightText {
    color: #888;
    margin-top: 20px;
  }

  .loginRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #d1d1d1;
  }

  .zuo {
    margin-right: 5px;
  }

  .you {
    display: flex;
    flex: 1;
    width: 90px;
    font-size: 16px;
  }

  .input {
    height: 46px;
    border: 1px solid white;
    padding: 10px;
    box-sizing: border-box;
    outline: none;
  }

  .bottowDiv {
    color: #FFFFFF;
    width: 300px;
    height: 35px;
    margin-top: 40px;
    background: #00C5F3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
  }

  .bottowDiv:active {
    opacity: 0.7;

  }

  .miniDiv {
    box-sizing: border-box;
    padding-top: 10px;
    padding-right: 10px;
    color: #eee;
    text-align: right;
    width: 100%;
    position: absolute;
    top: 0px;
  }

  .fsize {
    font-size: 12px;
    cursor: pointer;
    -webkit-app-region: no-drag;
    padding: 3px;
    border-radius: 50px;
    color: #000;
  }

  .fsize:hover {
    color: white;
    background-color: #3A3A3A;
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue